// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".social-media[data-v-30cdf418]{justify-content:center}@media screen and (min-width:768px){.social-media[data-v-30cdf418]{justify-content:right}}.copyright[data-v-30cdf418]{text-align:center}@media screen and (min-width:768px){.copyright[data-v-30cdf418]{text-align:left}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
